import { render, staticRenderFns } from "./qualityDetail.vue?vue&type=template&id=31ebb9e2&scoped=true"
import script from "./qualityDetail.vue?vue&type=script&lang=js"
export * from "./qualityDetail.vue?vue&type=script&lang=js"
import style0 from "./qualityDetail.vue?vue&type=style&index=0&id=31ebb9e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ebb9e2",
  null
  
)

export default component.exports